module.exports = __webpack_public_path__ + "static/media/customersSolution.b5e10593.svg";